import { useAssetVizInternal } from '@asset-viz/AssetVizInternalProvider'
import { PolygonFeatureLabel3D } from '../procedural/PolygonFeatureLabel3D'
import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from '../procedural/SurfaceLineFeature3D'
import {
  SurfaceMeshFeature3D,
  SurfaceMeshSelectionType,
} from '../procedural/SurfaceMeshFeature3D'
import React from 'react'
import { GeckoComponentPolygon, GeckoConicalPlate } from 'types'

/**
 * A component used to represent a conical plate on a component's surface
 * @param model             The asset model for this plate
 * @constructor
 */
export const ConicalPlateFeature3D: React.FC<{
  model: GeckoConicalPlate
}> = ({ model }) => {
  const { showPlateFeatureDebugColors } = useAssetVizInternal()

  const path = React.useMemo(
    () => GeckoComponentPolygon.CreateFromRect(model.geometry),
    [model.geometry]
  )

  return (
    <group key={model.id}>
      <SurfaceLineFeature3D
        path={path}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.LineForFeatureSelection}
      />

      <SurfaceMeshFeature3D
        path={path}
        featureModel={model}
        selectionType={SurfaceMeshSelectionType.AssetModelEditorSelectable}
        showDebugColors={showPlateFeatureDebugColors}
        userDataName={'plate'}
      />

      <PolygonFeatureLabel3D feature={model} polygonPath={path} />
    </group>
  )
}
